// extracted by mini-css-extract-plugin
module.exports = {"ssnGroup":"_adc1119","ssnDash":"_019884c"};